/**
 * Relations: two items that only show a problem when seen TOGETHER. The backend twin is
 * services/game_builder/mechanics/relations.py (it derives the pairs and snaps them on every build);
 * here the scene arranger uses the same `fits` rule while the creator drags.
 *   fits(host, part) -> { ok, spot }   boxes in % of the stage: x = centre, y = feet from the top, w, h
 *   text(part, host)                   the "kept together" line in the arranger
 */
import { createRegistry } from './registry';

export const RELATIONS = createRegistry('relation');

// Touching the host: centre inside the host's width, feet between the host's top and its feet.
const touching = (h, q) => q.x >= h.x - h.w / 2 && q.x <= h.x + h.w / 2 && q.y >= h.y - h.h && q.y <= h.y + 3;

RELATIONS.register({
  id: 'view',
  text: (part, host) => `📷 ${part} stays in ${host}'s view`,
  // In the camera's cone: below the camera, within ~1.5 camera-widths either side of it.
  fits: (h, q) => ({ ok: Math.abs(q.x - h.x) <= Math.max(h.w * 1.5, 6) && q.y - q.h >= h.y, spot: { x: h.x, y: Math.max(q.y, h.y + q.h + 4) } })
});
RELATIONS.register({
  id: 'against',
  text: (part, host) => `🔗 ${part} stays against ${host}`,
  fits: (h, q) => ({ ok: touching(h, q), spot: { x: h.x + h.w * 0.2, y: h.y } })
});
RELATIONS.register({
  id: 'on',
  text: (part, host) => `🔗 ${part} stays on ${host}`,
  fits: (h, q) => ({ ok: touching(h, q), spot: { x: h.x, y: h.y - h.h * 0.45 } })
});

/** The relation for a pair (an unknown one is treated as 'against', as the backend does). */
export const relationOf = (pair) => RELATIONS.get(pair.relation) || RELATIONS.get('against');
